import { SVGProps } from 'react';
const WebinarIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
    <rect x="0.5" y="0.5" width="47" height="47" rx="13.5" fill="#F3E8FD" />
    <rect x="0.5" y="0.5" width="47" height="47" rx="13.5" stroke="#D5B4F4" />
    <path
      d="M30.667 20.6663L31.5448 20.2274C34.1393 18.9301 35.4366 18.2815 36.3851 18.8677C37.3337 19.4539 37.3337 20.9043 37.3337 23.8051V24.1941C37.3337 27.0949 37.3337 28.5453 36.3851 29.1315C35.4366 29.7177 34.1393 29.0691 31.5448 27.7718L30.667 27.3329V20.6663Z"
      stroke="#8246AF"
      strokeWidth="2"
    />
    <path
      d="M26.0812 17.9198C26.8623 18.7008 26.8623 19.9671 26.0812 20.7482C25.3002 21.5292 24.0338 21.5292 23.2528 20.7482C22.4717 19.9671 22.4717 18.7008 23.2528 17.9198C24.0338 17.1387 25.3002 17.1387 26.0812 17.9198Z"
      stroke="#8246AF"
      strokeWidth="2"
    />
    <path
      d="M10.667 23.334C10.667 18.9507 10.667 16.759 11.8776 15.2839C12.0992 15.0138 12.3468 14.7662 12.6169 14.5446C14.092 13.334 16.2837 13.334 20.667 13.334C25.0503 13.334 27.242 13.334 28.7171 14.5446C28.9871 14.7662 29.2348 15.0138 29.4564 15.2839C30.667 16.759 30.667 18.9507 30.667 23.334V24.6673C30.667 29.0506 30.667 31.2423 29.4564 32.7174C29.2348 32.9875 28.9871 33.2351 28.7171 33.4567C27.242 34.6673 25.0503 34.6673 20.667 34.6673C16.2837 34.6673 14.092 34.6673 12.6169 33.4567C12.3468 33.2351 12.0992 32.9875 11.8776 32.7174C10.667 31.2423 10.667 29.0506 10.667 24.6673V23.334Z"
      stroke="#8246AF"
      strokeWidth="2"
    />
  </svg>
);
export default WebinarIcon;
